module.exports = __webpack_public_path__ + "media/images/top_menu_icon/machine_models_index-c1dde84ffa724a9756b4e9975a51d3b8.png";